import { useAuth0 } from "@auth0/auth0-react";
import { Button, Typography, useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import { LoadingIcon } from "../../components/ui/LoadingIcon";
import useAuth from "../../context/UserContext";

const ErrorPage = () => {
  const { logout: auth0Logout, isLoading } = useAuth0();

  const { loading } = useAuth();
  const theme = useTheme();

  const handleLogout = () => {
    auth0Logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  // TODO: Improve UX, loading not working as smoothly as it should
  if (loading || isLoading) return <LoadingIcon boxWidth="100vw" boxHeight="100vh" />;

  return (
    <Stack
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: 4,
        bgcolor: theme.palette.surfaceLight30.main,
      }}
    >
      <Typography variant="heading.four">You do not have access to any accounts in Switchboard.</Typography>
      <Button onClick={handleLogout}>Logout</Button>
    </Stack>
  );
};

export { ErrorPage };
